import type { GroupSelectOption } from '@rma/generic/ui/forms/group-select';
import { RmaIcons } from '@rma/generic/ui/icon';

type WhyAreYouHereType = GroupSelectOption & { icon?: RmaIcons };

export const WhyAreYouHereOptions = [
  { label: 'selling', value: 'selling', icon: 'attach_money' },
  { label: 'buying', value: 'buying', icon: 'add_home' },
  { label: 'renting', value: 'renting', icon: 'currency_exchange' },
] as const satisfies readonly WhyAreYouHereType[];

export type WhyAreYouHereOptionType = (typeof WhyAreYouHereOptions)[number]['value'];
